document.addEventListener('DOMContentLoaded', () => {
  document.modalMessage = $('#modalMessage');
  const modalMessageStartContent = document.modalMessage.html();

  document.modalMessage.on('hidden.bs.modal', () => {
    document.modalMessage.html(modalMessageStartContent);
  });

  // TODO: add public method with product remove option
  document.modalMessageShow = async (header, body) => {
    closeAllModals()
      .then(async () => {
        await new Promise((resolve) => {
          setTimeout(resolve, 500);
        });
        document.modalMessage.find('h3').text(header);
        document.modalMessage.find('.modal-body').replaceWith(body);
        document.modalMessage.modal('show');
      })
      .then(() => {
      });
  };

  document.modalMessageShowNow = (header, body) => {
    document.modalMessage.find('h3').text(header);
    document.modalMessage.find('.modal-body').replaceWith(body);
    document.modalMessage.modal('show');
    setTimeout(() => {
    }, 500);
  };

  document.modalMessageErrorShow = async () => {
    closeAllModals().then(async () => {
      await new Promise((resolve) => {
        setTimeout(resolve, 500);
      });
      document.modalMessage.find('h3').text('Что то пошло не так...');
      document.modalMessage
        .find('.modal-body')
        .replaceWith(
          '<div class="modal-body"><div class="form-modal form"><div class="title-h4 text-secondary">Наши специалисты уже работают над устранением проблемы.</div></div>',
        );
      document.modalMessage
        .find('.modal-footer')
        .replaceWith(
          '<div class="modal-text mt-4"> <strong>Пожалуйста попробуйте позже</strong> </div>',
        );
      document.modalMessage.modal('show');
    });
  };

  const closeAllModals = async () => {
    await new Promise((resolve) => {
      setTimeout(resolve, 300);
    });
    $('.modal').each((_, elem) => {
      $(elem).modal('hide');
    });
    await new Promise((resolve) => {
      setTimeout(resolve, 300);
    });
  };

  $('.modal').each((_, elem) => {
    $(elem).on('click', '[data-dismiss]', () => {
      const form = $(elem).find('form');
      if (form[0] !== undefined) {
        form.removeClass('was-validated');
        form[0].reset();
        form.find('.filepond--root').removeClass('filepond--error-required');
        form.find('.filepond--required-error').hide();
      }
    });
  });
});
